



























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { DataGrid, PageTitle } from '@questelservices/common-vue';
import { DxButton, DxPopup, DxSelectBox } from 'devextreme-vue';
import DxDataGrid, {
  DxColumn,
  DxLookup
} from 'devextreme-vue/data-grid';
import DevExpress from 'devextreme/bundles/dx.all';
import { BatchService } from '../../service/BatchService';
import { ClientService } from '../../service/ClientService';
import { SelectOption } from '../../models/SelectOption';
import { BatchDetailsDto } from '@/models/batch/BatchDetailsDto';
import { BatchSnapshotDto } from '@/models/batch/BatchSnapshotDto';
import { BatchSnapshotStatuses } from '../../models/batch/BatchSnapshotStatusEnum';
import dialog from 'devextreme/ui/dialog';
import { dxPolarChartArgumentAxisMinorTick } from 'devextreme/viz/polar_chart';
import DateTime from '@/utilities/DateTime';

@Component({
  components: {
    DataGrid,
    PageTitle,
    DxButton,
    DxColumn,
    DxLookup,
    DxSelectBox
  }
})
export default class BatchSnapshot extends Vue {
  $refs: Vue['$refs'] & {
    batchSnapshotDataGrid?: DataGrid;
  } = {};

  clients: Array<SelectOption> = [];
  selectedClientId: Guid = '';
  batches: Array<BatchDetailsDto> = [];
  selectedBatchId: Guid = '';
  batchName: string = '';
  batchSnapshots: Array<BatchSnapshotDto> = [];
  batchSnapshotStatuses: Array<SelectOption> = BatchSnapshotStatuses;

  batchService: BatchService = new BatchService();
  clientService: ClientService = new ClientService();
  
  constructor() {
    super();
  }

  mounted() {
    this.loadData();   
  }  

  async loadData() {
    let clients = await this.clientService.getAll();
    this.clients = clients.map(c => { return { text: c.ClientName, value: c.ClientId } });
  }

  @Watch('selectedClientId')
  private async onClientChange() {
    this.resetBatchData();
    if(this.selectedClientId) {
      await this.loadBatches();
    }
  }  

  @Watch('selectedBatchId')
  private async onBatchChange() {
    this.batchSnapshots = [];
    if (this.selectedBatchId != null && this.selectedBatchId != '') {
      this.batchSnapshots = await this.batchService.getBatchSnapshots(this.selectedBatchId);
    }
    this.refreshDataGrid();
  }

  private async loadBatches() {
    this.batches = await this.batchService.getClientBatches(this.selectedClientId, true);
    if (this.batches == null || this.batches.length == 0) {
      this.batches = [];
      this.selectedBatchId = '';
      this.batchName = '';  
    }
    else {
      let latestBatch = this.batches[0];
      this.selectedBatchId = latestBatch.BatchId;
      this.batchName = latestBatch.BatchName
    }     
  }

  private resetBatchData() {
    this.batches = [];
    this.selectedBatchId = '';
    this.batchName = '';    
  }

  get isClientSelected() {
    return this.selectedClientId != null && this.selectedClientId != '';
  }

  get isBatchSelected() {
    return this.selectedBatchId != null && this.selectedBatchId != '';
  }

  get showButtons() {
    return this.isClientSelected && this.isBatchSelected;
  }

  get BatchNameValue() {
    return this.batchName;
  }  

  private get dataStoreOptions() : DevExpress.data.CustomStoreOptions {
    return {
      key: 'BatchSnapshotId',
      loadMode: 'raw',
      load: () => { return this.batchSnapshots }
    }
  }

  private async snapshotBatch() {
    if (this.selectedBatchId != '') {
      let selectedBatch = this.batches.filter(x => x.BatchId == this.selectedBatchId)[0];
      let confirm = await dialog.confirm(`This operation will snapshot ${selectedBatch.MatterCount} matters with ${selectedBatch.LineItemCount} line items. Would you like to continue?`, 'Confirm');      
      if(confirm) {      
        await this.batchService.snapshotBatch(selectedBatch.BatchId);
        this.batchSnapshots = await this.batchService.getBatchSnapshots(selectedBatch.BatchId);    
        this.refreshDataGrid();
      }
    }    
  }

  private async refreshBatchSnapshots() {
    if (this.selectedBatchId != null)
    {
      this.batchSnapshots = await this.batchService.getBatchSnapshots(this.selectedBatchId);      
      this.refreshDataGrid();    
    }    
  }

  private refreshDataGrid() {
    if (this.$refs.batchSnapshotDataGrid) {
      (this.$refs.batchSnapshotDataGrid as any).refreshDataGrid();

      // set default sort to StartDate
      let datagrid = (this.$refs.batchSnapshotDataGrid.$refs.dxDataGrid as DxDataGrid).instance;
      if (datagrid) {
        datagrid.columnOption('StartDate', 'sortOrder', 'desc');
      }
    }    
  }
}
